import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TabBarBaseComponent } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
export class TabBarWebComponent extends TabBarBaseComponent {}
